import axios from 'axios'
import { API_BASE_URL } from '../services/apiService'

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

// Request interceptor - Add Authorization header to all requests
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('tenant_admin_token')

    // Add Authorization header if token exists
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // Add X-Original-Host header
    config.headers['X-Original-Host'] = window.location.hostname

    console.log('🚀 API Request:', {
      url: config.url,
      method: config.method,
      hasToken: !!token,
      headers: config.headers
    })

    return config
  },
  (error) => {
    console.error('❌ Request Error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor - Handle auth errors
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.data)
    return response
  },
  (error) => {
    console.error('❌ API Error:', error.response?.data || error.message)

    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      console.log('🔒 Unauthorized - Clearing auth data')
      localStorage.removeItem('tenant_admin_token')
      localStorage.removeItem('tenant_admin_user')

      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/user-login'
      }
    }

    return Promise.reject(error)
  }
)

export default api
